import { useState, useEffect, useRef } from "react";

function useInterval(callback: any, delay: number) {
  const [intervalActive, setIntervalActive] = useState(false);
  const savedCallback = useRef<any>();

  // Remember the latest callback.
  useEffect(() => {
    if (intervalActive) {
      savedCallback.current = callback;
    }
  }, [callback, intervalActive]);

  useEffect(() => {
    if (intervalActive) {
      const intervalId = setInterval(() => {
        if (savedCallback.current) {
          savedCallback.current();
        }
      }, delay);
      return () => clearInterval(intervalId);
    }
  }, [intervalActive, callback, delay]);
  return {
    start: () => {
      setIntervalActive(true);
    },
    stop: () => {
      setIntervalActive(false);
    },
  };
}

export default useInterval;
